import { useEffect, useState } from 'react'

/**
 * Clean urlReferral from current URL if it matches storedReferral in localStorage.
 * If urlReferral is different from storedReferral, do NOT update localStorage.
 * Returns the active urlReferral (string or null).
 */
export function getCleanUrlReferral(location, history) {
  if (!location) return localStorage.getItem('referral') || null

  const queryParams = new URLSearchParams(location.search)
  const urlReferral = queryParams.get('referral')
  const storedReferral = localStorage.getItem('referral')

  if (queryParams.has('referral')) {
    if (storedReferral !== null) {
      if (
        storedReferral === urlReferral ||
        storedReferral === `?referral=${urlReferral || ''}` ||
        storedReferral === '?referral=' ||
        urlReferral === ''
      ) {
        queryParams.delete('referral')
        const searchString = queryParams.toString()
        const searchPath = searchString ? `?${searchString}` : ''

        if (history && history.replace) {
          history.replace({
            pathname: location.pathname,
            search: searchPath
          })
        }
      }
    } else {
      return urlReferral !== null ? urlReferral : ''
    }
  }

  return urlReferral || null
}

/**
 * If active URL has ?referral=, append it to targetPath when navigating.
 */
export function appendReferralIfPresent(targetPath, location) {
  if (!location || !location.search) return targetPath

  const queryParams = new URLSearchParams(location.search)
  if (queryParams.has('referral')) {
    const urlReferral = queryParams.get('referral')
    const [basePath, searchStr] = targetPath.split('?')
    const targetParams = new URLSearchParams(searchStr || '')
    targetParams.set('referral', urlReferral !== null ? urlReferral : '')
    const newSearch = targetParams.toString()
    return `${basePath}?${newSearch}`
  }

  return targetPath
}

export default function useReferralSanitizer(history, location) {
  const [activeReferral, setActiveReferral] = useState(() => getCleanUrlReferral(location, history))

  useEffect(() => {
    const cleanReferral = getCleanUrlReferral(location, history)
    setActiveReferral(cleanReferral)
  }, [history, location?.search, location?.pathname])

  return activeReferral
}
